import EventBus from '/@/modules/core/app/helpers/EventBus';
import Logger from '/@/modules/core/app/helpers/Logger';

export const EventBusPlugin = {
  install(app) {
    app.mixin({
      beforeCreate() {
        const { events } = this.$options;
        if (events && typeof events !== 'function') {
          Logger.log('Expected option events to be only a function', Logger.LEVEL_ERROR);
        }

        this.__attachedHandlers = {};
      },
      created() {
        // Skip event registration for:
        // 1. Vue Test Utils' internal wrapper components (VTU_ROOT)
        // 2. Stubs created by StubFactory (identified by -stub in template)
        if (this.$options.name === 'VTU_ROOT' || this.$options.name === 'VTUROOT') {
          return;
        }

        const template = this.$options.template || '';
        if (typeof template === 'string' && template.includes('-stub>')) {
          return;
        }

        if (this.$options.events) {
          const eventHandlersMap = this.$options.events.call(this);
          Object.entries(eventHandlersMap).forEach(([eventName, handlerMethod]) => {
            // console.log(`[EventBusPlugin] Registering event "${eventName}" for component "${this.$options.name}"`);
            this.__attachedHandlers[eventName] = handlerMethod;
            EventBus.listen(eventName, handlerMethod);
          });
        }
      },
      beforeUnmount() {
        if (Object.keys(this.__attachedHandlers).length > 0) {
          Object.entries(this.__attachedHandlers).forEach(([eventName, handlerMethod]) => {
            EventBus.destroy(eventName, handlerMethod);
          });

          this.__attachedHandlers = {};
        }
      }
    });

    // Vue 3 compatible merge strategy for events option
    app.config.optionMergeStrategies.events = function (toVal, fromVal) {
      if (!toVal) {
        return fromVal;
      }
      if (!fromVal) {
        return toVal;
      }

      // Both exist - merge them by creating a function that calls both
      // and merges their results (parent first, then child overrides)
      return function mergedEvents() {
        const parentEvents = typeof fromVal === 'function' ? fromVal.call(this) : fromVal;
        const childEvents = typeof toVal === 'function' ? toVal.call(this) : toVal;

        return {
          ...parentEvents,
          ...childEvents
        };
      };
    };
  }
};
